// extracted by mini-css-extract-plugin
module.exports = {"customBlueButton":"FilterSearchPageHeading_customBlueButton__azH8O"};